module.exports = "<p>\n  school-app-student-status-base works!\n</p>\n"